/**
 * @generated SignedSource<<6e26ca80db52d275b7a78f6d23390518>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedContactDealerWrapper_user";
};
export type SharedContactDealerWrapper_user$key = {
  readonly " $data"?: SharedContactDealerWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ed3b236b1f1d92ed75de332348a5887d";

export default node;
